
const digest = 'e6a90867936bf395566c286daa24d42fa98ad480cd114b34c036f555d7348006';
const classes = {"wrapper":"_wrapper_16tp8_1","indicator":"_indicator_16tp8_11","label":"_label_16tp8_18","price":"_price_16tp8_24"};
const css = `._wrapper_16tp8_1 {
  width: 278px;
  height: 116px;
  border-radius: 5px;
  box-shadow: 0 4px 0 0 var(--background);
  border: solid 1px var(--border);
  background-color: #fff;
  position: relative;
  padding: 32px;
}
._wrapper_16tp8_1 ._indicator_16tp8_11 {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 6px;
}
._wrapper_16tp8_1 ._label_16tp8_18 {
  font-size: 14px;
  font-family: Rubik;
  color: #9ea0a5;
  margin-bottom: 8px;
}
._wrapper_16tp8_1 ._price_16tp8_24 {
  font-size: 24px;
  font-family: Rubik;
  font-weight: 500;
  color: #000;
  margin: 0;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  